export class AsyncDecorators {
    public static cacheFirstSuccessfulPromise() {
        return function (_target: any, _name: string, property: any) {
            const fn = property.value;
            let cachedSuccessfulPromise: Promise<any>;
            property.value = function (...args: any[]) {
                if (!cachedSuccessfulPromise) {
                    const promise = fn.apply(this, args);

                    // Only cache promise on success
                    return promise.then((p: any) => {
                        cachedSuccessfulPromise = promise;
                        return p;
                    });
                }
                return cachedSuccessfulPromise;
            };
        };
    }
}
